import type { ChargerPowerGauge } from "../types/charger";

/** Tile readout: `10/11`, `0/11`, `0`, `3/?`, or hidden when idle (no gauge). */
export function formatPowerGauge(gauge: ChargerPowerGauge | null | undefined): string | null {
  if (gauge == null) return null;

  const current = gauge.current ?? 0;
  const max = gauge.max ?? null;
  const unassessed = max == null || max <= 0;

  if (current <= 0) {
    if (max != null && max > 0) return `0/${max}`;
    return "0";
  }

  if (unassessed) return `${current}/?`;
  return `${current}/${max}`;
}
